<script setup>
import {defineEmits, ref, toRef} from 'vue';
import {TrashIcon} from '@heroicons/vue/20/solid'

const props = defineProps({
  passenger: Object,
});
const passenger = ref(props.passenger);
const emits = defineEmits(['remove-passenger']);
const removePassenger = () => {
  emits('remove-passenger');
};

</script>

<template>
  <div
      class="relative flex flex-col items-start px-6 py-5 bg-white border border-gray-300 rounded-lg shadow-sm focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:border-gray-400">
    <div class="flex items-center justify-start mb-2">
      <span class="text-gray-500">
        <img alt="Flag" class="w-6 h-4 mr-2"
             :src="`https://flagcdn.com/${passenger.nationalityCountryCode?.toLowerCase()}.svg`">
      </span>
      <h2 class="text-lg font-semibold">
        {{ passenger.firstName }} {{ passenger.lastName }}
      </h2>
    </div>
    <div class="mb-2">
      <p class="text-gray-700"><span class="font-bold">Email :</span> {{ passenger.email || 'N/A' }}</p>
      <p class="text-gray-700"><span class="font-bold">Numéro de billet :</span> {{ passenger.ticketNumber || 'N/A' }}
      </p>
    </div>
    <TrashIcon @click="removePassenger"
               class="absolute w-5 h-5 fill-red-400 top-2 right-2"/>
  </div>
</template>
